import React from "react";
import { Alert } from "reactstrap";

const AlertSection = ({ formik, getTotalPayments }) => {
  return (
    <>
      {getTotalPayments() > parseInt(formik.values.settled_price) && (
        <Alert color="danger" className="mt-3" fade={false}>
          <div className="d-flex align-items-center">
            <span className="me-2">⚠️</span>
            Amount exceeds total price by: €
            {Intl.NumberFormat("en-US").format(
              (parseInt(formik.values.settled_price) - getTotalPayments()) * -1
            )}
          </div>
        </Alert>
      )}

      {formik.errors.remaining_balance && (
        <Alert color="danger" className="mt-3" fade={false}>
          <div className="d-flex align-items-center">
            <span className="me-2">⚠️</span>
            Please set all payments until the remaining amount is 0
          </div>
        </Alert>
      )}
    </>
  );
};

export default AlertSection;
